export const LANGUAGES = 'languages';
export const LANGUAGE = 'language';
export const ADMINS = 'admins';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const EMAIL = 'email';
export const EMAILS = 'emails';
export const NAME = 'name';
export const TYPE = 'type';
export const COUNTRY = 'country';
export const DESCRIPTION = 'description';
export const AUTHENTICATION_TYPE = 'authenticationType';
export const AUTHENTICATION_SETUP = 'authenticationSetup';
export const AUTHENTICATION_GOOGLE = 'google';
export const AUTHENTICATION_MICROSOFT = 'microsoft';
export const AUTHENTICATION_APP = 'authenticationApp';
export const SMS_CODE = 'code';
export const PHONE = 'phone';
export const VERIFICATION_CODE = 'code';
export const PASSWORD = 'password';
export const COMPANY_LOGO = 'companyLogo';
export const PARTNER_LOGO = 'partnerLogo';
export const PRIMARY_COLOR = 'primary';
export const SECONDARY_COLOR = 'secondary';
export const HEADINGS_COLOR_1 = 'headings1';
export const HEADINGS_COLOR_2 = 'headings2';
export const SUBTITLE_COLOR = 'subtitle';
export const CURRENT_PASSWORD = 'currentPassword';
export const REPEAT_NEW_PASSWORD = 'repeatPassword';
export const ID = 'id';
export const SEARCH = 'search';
export const FILTER_BY_STATUS = 'filterByStatus';
export const ROLE = 'role';
export const STATUS = 'status';
export const PILLARS = 'pillars';
export const PILLAR_MODULES = 'pillarModules';
export const CAN_VIEW = 'canView';
export const PILLAR_ID = 'pillarId';
export const ACCESS = 'access';
export const SSO = 'sso';
export const MFA_APP = 'mfaApp';
export const MFA_SMS = 'mfaSms';
export const VALUE_CHAIN_EDITING_ACCESS = 'valueChainEditingAccess';
export const VALUE_CHAIN_LINKING_ACCESS = 'valueChainLinkingAccess';
export const USER_MANAGEMENT_ACCESS = 'userManagementAccess';
export const MULTI_LINGUAL_ACCESS = 'multiLingualAccess';
export const UI_CONFIGURATION_ACCESS = 'UIConfigurationAccess';
export const DATA_SETS_MANAGEMENT_ACCESS = 'dataSetsManagementAccess';
export const REASON = 'reason';
export const SORT = 'sort';
export const ORDER_KEY = 'orderKey';
export const ORDER_TYPE = 'orderType';
export const DATA_SET_UPLOAD_FILE = 'dataSetUploadFile';
export const MAPPING_TARGET = 'mappingTarget';
export const MAPPING_SOURCES = 'mappingSources';
export const SHOW_ARCHIVED = 'showArchived';
export const SELECTED_ITEMS = 'selectedItems';
export const SELECT_ALL = 'selectAll';
export const PROFIT_CENTRE_NAME = 'name';
export const PROFIT_CENTRE_UNIQUE_IDENTIFIER = 'uniqueIdentifier';
export const REVENUE_ROLLING_PERCENTS = 'totalRevenueRolling12MPercents';
export const GROSS_MARGIN_ROLLING_PERCENTS = 'totalGrossMarginRolling12MPercents';
export const REVENUE_ROLLING_AMOUNT = 'totalRevenueRolling12MActual';
export const GROSS_MARGIN_ROLLING_AMOUNT = 'totalGrossMarginRolling12MActual';
export const FINISHED_GOOD_STOCK_AMOUNT = 'wipFinishedGoodsStock';
export const REVENUE_ROLLING_CURRENCY = 'totalRevenueRolling12MActual_currency';
export const GROSS_MARGIN_ROLLING_CURRENCY = 'totalGrossMarginRolling12MActual_currency';
export const FINISHED_GOOD_STOCK_AMOUNT_CURRENCY = 'wipFinishedGoodsStock_currency';
export const ORG_TYPE_PREFIX = 'orgTypePrefix';
export const GEO_TYPE_PREFIX = 'geoTypePrefix';
export const ORG_PATH = 'orgPath';
export const OLD_ORG_PATH = 'oldOrgPath';
export const UNIQUE_IDENTIFIER = 'uniqueIdentifier';
export const LEGAL_NAME = 'legalName';
export const PROFIT_CENTER_ID = 'profitCenterId';
export const VALUE_CHAIN_SECTION = 'valueChainSection';
export const VALUE_CHAIN_LIST = 'valueChainList';
export const OWNERSHIP = 'ownership';
export const EQUITY_SHAREHOLDING = 'equityShareholding';
export const FINANCIAL_CONTROL = 'financialControl';
export const BUSINESS_UNIT_TYPE = 'businessUnitType';
export const ASSET_CATEGORY = 'assetCategory';
export const OWNED_LEASED = 'ownedLeased';
export const NUMBER_OF_EMPLOYEES = 'numberOfEmployees';
export const DATE_OPENED = 'dateOpened';
export const DATE_CLOSED = 'dateClosed';
export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const NET_BOOK = 'netBookValue';
export const NET_BOOK_CURRENCY = 'netBookValue_currency';
export const ADDRESS_COUNTRY = 'addressCountry';
export const ADDRESS_STATE = 'addressState';
export const ADDRESS_POST_CODE = 'addressPostCode';
export const ADDRESS_CITY = 'addressCity';
export const ADDRESS_STREET = 'addressStreet';
export const ADDRESS_BUILDING = 'addressBuilding';
export const ADDRESS_COORDINATES = 'addressCoordinates';
export const CODE = 'code';
export const UPSTREAM_TIER = 'upstreamTier';
export const SPEND = 'spend';
export const SPEND_CURRENCY = 'spend_currency';
export const KEY_SUPPLIER_TIER_1_TOTAL = 'keySupplierTier1Total';
export const KEY_SUPPLIER_TIER_1_TOTAL_CURRENCY = 'keySupplierTier1Total_currency';
export const KEY_SUPPLIER_TIER_10_OF_TOTAL = 'keySupplierTier1OfTotal';
export const SUPPLIER_LINKS = 'supplierLinks';
export const VOLUME_QTY = 'volumeQty';
export const VOLUME_QTY_UNIT = 'volumeQtyUnit';
export const PRODUCT_TYPE = 'productType';
export const EQUITY_CONTROL = 'equityControl';
export const EXPECTED_GROWTH_DECLINE = 'expectedGrowthDecline';
export const RELIANCE_ON_FREE_NATURAL_RESOURCES = 'relianceOnFreeNaturalResources';
export const RELIANCE_ON_FREE_SOCIAL_RESOURCES = 'relianceOnFreeSocialResources';
export const CRITICALITY_RATING = 'criticalityRating';
export const CRITICALITY_FROM_DOWNSTREAM_WASTE = 'circularityFromDownstreamWaste';
export const EXPECTED_GROWTH_NEXT_12M = 'expectedGrowthDecline';
export const PRIORITY_RATING = 'priorityRating';
export const CONNECTION_TYPE = 'connectionType';
export const COMMENT_LOGICAL = 'commentLogical';
export const MANUFACTURE_CONNECTION_TYPE = 'manufactureConnectionType';
export const COMMENT_MANUFACTURE = 'commentManufacture';
export const OWNERSHIP_PERCENTAGE = 'ownershipPercentage';
export const AIR = 'air';
export const SEA = 'sea';
export const RAIL = 'rail';
export const VAN = 'van';
export const TRUCK = 'truck';
export const RIGID_TRUCK = 'rigidTruck';
export const ARCTIC_TRUCK = 'articTruck';
export const DISTANCE = 'distance';
export const MONETARY_VOLUMES = 'monetaryVolumes';
export const UNIT_MONETARY_VOLUMES = 'unitMonetaryVolumes';
export const QUANTITY = 'quantity';
export const UNIT_CURRENCY = 'unitCurrency';
export const TYPE_OF_SERVICE_PROVIDER = 'typeOfServiceProvider';
export const MONETARY_VALUES = 'monetaryValues';
export const UNIT_CURRENCY_VALUES = 'unitCurrencyValues';
export const COMMENT_SERVICE = 'commentService';
export const ID_LOGICAL = 'idLogical';
export const ID_SUPPLIER = 'idSupplier';
export const ID_SERVICE = 'idService';
export const ID_MANUFACTURE = 'idManufacture';
export const ID_TO_LOGICAL = 'idToLogical';
export const ID_TO_SUPPLIER = 'idToSupplier';
export const ID_TO_SERVICE = 'idToService';
export const ID_TO_MANUFACTURE = 'idToManufacture';
export const ID_FROM = 'idFrom';
export const CURRENCY = 'currency';
export const STRUCTURE = 'geoPath';
export const NACE_SECTION = 'naceSection';
export const NACE_CODE = 'naceCode';
export const EU_TAXONOMY_CODE = 'euTaxonomyCode';
export const PROFIT_CENTER_IDS = 'profitCenterIds';
export const TOTAL_COST = 'totalCost';
export const TOTAL_COST_CURRENCY = 'supplierTotalCostCurrency';
export const PERCENT_OF_TOTAL_COST = 'percentOfTotalCost';
export const PROFIT_CENTER_LINKS = 'profitCenterLinks';
// Every inbound source of a product, of both connection kinds, as one list. It is split back
// into the two arrays the API stores on submit; the panel shows it as one list because that is
// how a user thinks of "where this product comes from". `SOURCING_KIND` is the per-row tag that
// decides which array a row is sent in and which fields its card renders.
export const SOURCING_CONNECTIONS = 'sourcingConnections';
export const SOURCING_KIND = 'kind';
// Per-item fields of a `sourcingConnections` entry. `CONNECTION_ID` is absent on an
// item the user has just added, which is what tells the backend to create rather than update.
export const CONNECTION_ID = 'id';
export const FROM_UNIT_ID = 'fromUnitId';
// Display-only copies of the `from` summary the record GET returns. They are stripped before
// an item is sent: the request DTO whitelists its properties and rejects anything else.
export const FROM_NAME = 'fromName';
export const FROM_TYPE = 'fromType';
export const TOTAL_GROSS_PROFIT_PERCENTS = 'totalGrossProfitPercents';
export const TOTAL_REVENUE_PERCENTS = 'totalRevenuePercents';
export const TASK_NAME = 'taskName';
export const TASK_RELATE_TO = 'taskRelateTo';
export const TASK_ASSIGNED_TO = 'taskAssignedTo';
export const TASK_DESCRIPTION = 'taskDescription';
export const TASK_START_DATE = 'taskStartDate';
export const TASK_END_DATE = 'taskEndDate';
export const TASK_DURATION = 'taskDuration';
export const TASK_PRIORITY = 'taskPriority';
export const RELATE_TO = 'relateTo';
export const RELATE_TO_MA = 'relateToMA';
export const COMMENT_TASK = 'commentTask';
export const VALUE_CHAIN_MAPS = 'valueChainMaps';
export const STANDARDS = 'standards';
export const INVESTOR = 'investor';
export const CONTACT_NAME = 'contactName';
export const CONTACT_EMAIL = 'contactEmail';
export const EQUITY = 'equity';
export const SHARE_CATEGORY = 'shareCategory';
export const DURATION_OF_INVESTMENT = 'durationOfInvestment';
export const BOARD_MEMBER_NAME = 'boardMemberName';
export const BOARD_MEMBER_PROFESSION = 'boardMemberProfession';
export const BOARD_MEMBER_CATEGORY = 'boardMemberCategory';
export const EMPLOYEE_REPRESENTATIVE_NAME = 'employeeRepresentativeName';
export const DEPARTMENT = 'department';
export const COMMUNITY_GROUP_NAME = 'communityGroupName';
export const REPRESENTATION_CATEGORY = 'representationCategory';
export const REPRESENTATIVE_NAME = 'representativeName';
export const INTERNAL_LIAISON = 'internalLiaison';
export const INTERNAL_LIAISON_EMAIL = 'internalLiaisonEmail';
export const MEDIA_ORGANISATION_NAME = 'mediaOrganisationName';
export const RELEVANCE_TO_COMPANY = 'relevanceToCompany';
export const NGO_NAME = 'ngoName';
export const NGO_CONTACT_NAME = 'ngoContactName';
export const NGO_CONTACT_EMAIL = 'ngoContactEmail';
export const QUESTION = 'question';
export const QUESTION_TYPE = 'questionType';
export const QUESTION_SOURCE_TYPE = 'questionSourceType';
export const COMPANY_NAME = 'companyName';
export const SOURCE = 'source';
export const DISCLOSURE = 'disclosure';
export const CATEGORY = 'category';
export const REQUIRED_BY = 'requiredBy';
export const STOCK_TICKER = 'stockTicker';
export const WEBSITE = 'website';
export const SEER_COMPETITOR = 'seerCompetitor';
export const SECTOR = 'sector';
export const SIZE_MIN = 'sizeMin';
export const SIZE_MAX = 'sizeMax';
export const SPECIFIC_SENSITIVITY = 'specificSensitivity';
export const SECTOR_CODE = 'sectorCode';
export const INDUSTRY_CODE = 'industryCode';
export const SELECT_ITEM = 'selectItem';
export const TOPIC = 'topic';
export const MA_ID = 'maId';
export const QUESTIONS = 'questions';
export const IS_COMMENTABLE = 'isCommentable';
export const OPTIONS = 'options';
export const STANDARD_ID = 'standardId';
export const INSIGHT_ID = 'insightId';
export const RESPONDENT_TYPE = 'respondentType';
export const ITEMS = 'items';
export const QUESTION_ID = 'questionId';
export const TEXT_ANSWER = 'textAnswer';
export const SELECTED_OPTION_ID = 'selectedOptionId';
export const SELECTED_OPTION_IDS = 'selectedOptionIds';
export const PRIORITIZED_OPTIONS = 'prioritizedOptions';
export const PRIORITY = 'priority';
export const PRIORITY_ITEM = 'PriorityItem';
export const OPTION_ID = 'optionId';
export const COMMENT = 'comment';
export const RULES = 'rules';
export const TOPIC_ID = 'topicId';
export const SUB_TOPIC_ID = 'subTopicId';
export const POSITION = 'position';
export const TEMPLATE = 'template';
export const STAKEHOLDER = 'stakeholder';
export const COEFFICIENT = 'coefficient';
export const COEFFICIENT_KEY = 'coefficientKey';
export const APPLY_COEFFICIENT = 'applyCoefficient';
export const SUPPLIERS_EXPENSES = 'suppliersExpenses';
export const PURCHASE_VOLUME = 'purchaseVolume';
export const PROFIT = 'profit';
export const STAKEHOLDER_TYPE = 'stakeholderType';
export const CREATED_AT = 'createdAt';
export const UPDATED_AT = 'updatedAt';
export const QUESTION_COUNT = 'questionsCount';
export const REPORTING_FRAMEWORK = 'reportingFramework';
export const IRO_CATEGORY = 'iroCategory';
export const IMPACT_STATUS = 'impactStatus';
export const POSITION_ON_VALUE_CHAINS = 'positionOnValueChains';
export const IRO_DESCRIPTION = 'iroDescription';
export const ESTIMATED = 'estimated';
export const QUESTION_RADIO = 'questionRadio';
export const QUESTION_SELECT = 'questionSelect';
// MAIro Question Answer Schema constants
export const QUESTIONNAIRE_ID = 'questionnaireId';
export const ANSWER_ID = 'answerId';
export const RATE = 'rate';
export const REJECT_REASON = 'rejectReason';
export const FILE_NAME = 'fileName';
export const ORIGINAL_FILE_NAME = 'originalFileName';
export const MIME_TYPE = 'mimeType';
export const FILE_SIZE = 'fileSize';
export const FILE_URL = 'fileUrl';
export const ATTACHMENTS = 'attachments';
export const QUESTIONNAIRE_RECIPIENT_ID = 'questionnaireRecipientId';
export const VALUE_CHAIN_MAP = 'valueChainMap';
export const PRODUCT_CATEGORY_ID = 'productCategoryId';
export const AFFECTED_PERIOD = 'affectedPeriod';
export const AFFECTED_PERIOD_UNIT = 'affectedPeriodUnit';
export const PRODUCTIVITY_IMPACT = 'productivityImpact';
export const UNIT_IDS = 'unitIds';
